/** @format */

import { notificationConstants } from '../notifications/notifications';
import { apiCall } from '../../core/apiCall';
import { defaultActions } from '../../core/actionsDefault';
import { actionDebug } from '../../core/debug';

// const _ = require('underscore');

export const fractionsConstants = {
    LIST: 'fractions_list',
    ITEM: 'fractions_item',
    EDIT: 'fractions_edit',
    DELETE: 'fractions_delete',
    MANAGE: 'fractions_manage',
    ADD: 'fractions_add',
};

export class fractionsActions extends defaultActions {
    static getFractionsList = (url, filter) => {
        return (dispatch) => {
            apiCall
                .get(url, filter)
                .then((collections) => {
                    dispatch(success(collections));
                })
                .catch((error) => {
                    dispatch(failure(error));
                });
        };

        function success(collections) {
            return { type: fractionsConstants.LIST, collections: collections };
        }

        function failure(error) {
            return { type: notificationConstants.ERROR };
        }
    };

    static get = (url) => {
        return (dispatch) => {
            apiCall
                .get(url)
                .then((item) => {
                    dispatch(success(item));
                })
                .catch((error) => {
                    if (error.status === 404) {
                        dispatch(itemNotFound(error));
                    } else {
                        dispatch(failure(error));
                    }
                });
        };

        function success(item) {
            return { type: fractionsConstants.ITEM, item: item };
        }

        function itemNotFound(error) {
            return { type: notificationConstants.NOTFOUND, error: error };
        }

        function failure(error) {
            return { type: notificationConstants.ERROR };
        }
    };

    static post = (url, params) => {
        actionDebug(params);
        return (dispatch) => {
            apiCall
                .post(url, params)
                .then((data) => {
                    dispatch(success(data));
                })
                .catch((error) => {
                    dispatch(failure(error));
                });
        };

        function success(data) {
            return { type: fractionsConstants.ADD, data: data };
        }

        function failure(error) {
            return {
                type: notificationConstants.ERROR,
                error: error,
            };
        }
    };

    static put = (url, params) => {
        return (dispatch) => {
            apiCall
                .put(url, params)
                .then((data) => {
                    dispatch(success(data));
                })
                .catch((error) => {
                    dispatch(failure(error));
                });
        };

        function success(data) {
            return { type: fractionsConstants.EDIT, data: data };
        }

        function failure(error) {
            return {
                type: notificationConstants.ERROR,
                error: error,
            };
        }
    };

    static remove = (url) => {
        return (dispatch) => {
            apiCall
                .remove(url)
                .then(dispatch(success()))
                .catch((error) => {
                    failure(error);
                });
        };

        function success() {
            return { type: fractionsConstants.DELETE };
        }

        function failure(error) {
            return {
                type: notificationConstants.ERROR,
                error: error,
            };
        }
    };
}
